export default __webpack_public_path__ + "static/media/ico-chevron-reg-up.d9b7ed42.svg";